import axios from 'axios';

export const instance = axios.create({
	withCredentials: true
});

export const appInstance = axios.create({
	withCredentials: true
});

export const apiBaseURL = () => appInstance.defaults.baseURL;
